export default __webpack_public_path__ + "static/media/communication_disorders.fa3c367b.jpg";